/* ============
 * Supplier Index
 * ============
 *
 * This page shows the list of Bills.
 */
import moment from 'moment';
import { mapGetters, mapMutations } from 'vuex';
import adjustmentService from './../../../../services/adjustment';
import accountService from './../../../../services/account';
import debounce from 'debounce';
import SearchMixin from './../../../../mixins/search';
import BridgeHandoffMixin from './../../../../mixins/bridgeHandoff';

export default {
  data() {
    return {
      loading: true,
      sortValue: '',
      limit: 25,
    };
  },

  computed: {
    ...mapGetters({
      adjustments: 'paginateAdjustments',
    }),

    adjustmentsList() {
      return this.adjustments.items.map((b) => {
        return b;
      });
    },
  },

  watch: {

    adjustments: function(adjustments) {},
    /**
     * Listem to router changes, used to check query params that have changed to apply filters.
     *
     * @param  {Object} route Current route object.
     */
    $route() {
      this.all(1, 25);
    },
  },

  components: {
    VCard: require('./../../../../components/card/card.vue'),
    VPagination: require('./../../../../components/paginationNew/paginationNew.vue'),
    VNoData: require('./../../../../components/noData/noData.vue'),
  },

  mixins: [
    SearchMixin,
    BridgeHandoffMixin,
  ],

  mounted() {
    this.setInnerSidebar([{
        title: this.$t('static.inventory.transaction.title'),
        options: [{
            title: this.$t('static.stock.filters.title'),
            route: {
              name: 'inventory.stock.index',
            },
          },
          {
            title: this.$t('static.adjustment.filters.title'),
            route: {
              name: 'inventory.adjustment.index',
            },
          },
          {
            title: this.$t('static.purchase.filters.title'),
            route: {
              name: 'inventory.purchase.index',
            },
          },
          {
            title: this.$t('static.transfer.filters.title'),
            route: {
              name: 'inventory.transfer.index',
            },
          },
        ],
        button: this.bridgeStockWriteBlocked ? null : {
          title: `+ ${this.$t('static.warehouse.addTransaction.title')}`,
          route: {
            name: 'inventory.transaction.index',
          },
        },
      },

      {
        title: this.$t('static.warehouse.filters.title'),
        options: [{
            title: this.$t('static.warehouse.filters.view'),
            route: {
              name: 'warehouse.index',
            },
          },
        ],
        button: {
          title: `+ ${this.$t('static.warehouse.create.title')}`,
          route: {
            name: 'warehouse.create',
          },
        },
      },
    ]);
    
    accountService.rememberPerPage('get', {from: 'adjustment'})
    .then((data) => {
      this.limit = data.size;
      this.all(1, this.limit);
    }).catch((error) => {
      console.log(error);
    });
  },

  destroyed() {
    this.unsetInnerSidebar();
  },

  methods: {
    ...mapMutations({
      setInnerSidebar: 'SET_INNERSIDEBAR',
      unsetInnerSidebar: 'UNSET_INNERSIDEBAR',
    }),

    formatDate(value, pattern = 'DD-MM-YYYY') {
      if (!value) {
        return '-';
      }
      const m = moment(value);
      return m.isValid() ? m.format(pattern) : '-';
    },

    perPage(size){
      accountService.rememberPerPage('post', {from: 'adjustment', perPage: size })
      .then((data) => {
        this.limit = data.size;
      }).catch((error) => {
        console.log(error);
      });
    },

    /**
     * Fetches paginated adjustment.
     *
     * @param  {int} page The page number.
     * @param  {int} limit The number of items displayed on a page.
     */
    all: debounce(function(page, limit) {
      this.loading = true;
      adjustmentService.items({
        page,
        limit,
        search: this.getSearch(this.limit),
        filter: this.$route.query.filter,
      }).then(() => {
        this.loading = false;
      }).catch(() => {
        this.loadProductsing = false;
      });
    }, 800),

    /**
     * Go to edit view for adjustment.
     *
     * @param  {Object} adjustment The adjustment object.
     */
    editAdjustment(adjustment) {
      let name = 'inventory.adjustment.view';
      if (adjustment.status === 'draft' || adjustment.status === 'pending') {
        name = 'inventory.adjustment.stock.edit';
      }
      this.$router.push({
        name,
        params: { id: adjustment.id },
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/app/pages/withNavigation/adjustment/index/index.js